export enum SystemTemplate {
  Default = 'default',
  SchoolShuttles = 'schoolShuttles',
  Employees = 'employees',
  Trailers = 'trailers',
}
